import React, { useRef, useState } from 'react'
import DeviceDropdown from '../DeviceDropdown'
import { IMinimalDevice } from '../../LoanerVehicles'
import { Tooltip } from '@mui/material'

import styles from './LoanerVehicleSelector.module.scss'

interface ILoanerVehicleSelectorProps {
  availableDevices: IMinimalDevice[]
  selectedDevice: IMinimalDevice | null
  onSelect: (device: IMinimalDevice) => void
  isEditing: boolean
}

const LoanerVehicleSelector = ({
  availableDevices,
  selectedDevice,
  onSelect,
  isEditing,
}: ILoanerVehicleSelectorProps) => {
  const [showDropdown, setShowDropdown] = useState(false)
	const triggerRef = useRef<HTMLButtonElement>(null)

  if (!isEditing) {
    return (
      <span className={styles.readonlyText}>{selectedDevice?.name || ' '}</span>
    )
  }

  const handleDeviceSelect = (device: IMinimalDevice) => {
    onSelect(device)
    setShowDropdown(false)
  }

  return (
    <div className={styles.selectorWrapper}>
      <Tooltip title="Select vehicle" placement="top">
        <button
          ref={triggerRef}
          className={styles.triggerInput}
          onMouseDown={() => setShowDropdown(!showDropdown)}
        >
          {selectedDevice ? (
            <span className={styles.selectedText}>{selectedDevice.name}</span>
          ) : (
            <span className={styles.placeholder}>Select vehicle</span>
          )}
        </button>
      </Tooltip>

      <DeviceDropdown
        devices={availableDevices}
        onSelect={handleDeviceSelect}
        isOpen={showDropdown}
        onClose={() => setShowDropdown(false)}
        placeholder="Search loaner vehicles..."
				triggerElement={triggerRef.current}
      />
    </div>
  )
}

export default LoanerVehicleSelector

